<template>
  <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.8828 0.11715C23.7736 0.00715005 23.6096 -0.0288499 23.4636 0.0239501L0.263575 8.42395C0.112375 8.47875 0.00837467 8.61915 0.000374666 8.77995C-0.00762533 8.94075 0.0815747 9.09075 0.226775 9.16075L8.58117 13.1707L16.1276 7.59275C16.3124 7.45635 16.544 7.68795 16.4072 7.87235L10.8296 15.4187L14.8396 23.7731C14.9064 23.9119 15.0468 24 15.2 24C15.2068 24 15.2132 24 15.22 23.9995C15.3808 23.9911 15.5212 23.8875 15.5764 23.7363L23.9764 0.53635C24.0288 0.39035 23.9924 0.22675 23.8828 0.11715Z"/>
</svg> -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path
      d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z"
    />
    <path d="M6.5 12h14.5" />
  </svg>
</template>
